import { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from './components/Layout';
import { API_BASE_URL } from '../config/ApiConfig';
import { useNavigate } from 'react-router-dom';
import LoadingModal from './components/modals/LoadingModal';
import useDefaultModal from './components/hooks/useDefaultModal';
import useConfirmModal from './components/hooks/useConfirmModal';
import ConfirmModal from './components/modals/ConfirmModal';
import DefaultModal from './components/modals/DefaultModal';
import ResponsiveShadow from './components/ResponsiveShadow';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import ImagemModal from './components/modals/ImagemModal';
import './css/Imagem.css';
import DataTable from './components/DataTable';
import TableContainer from './components/TableContainer';

function Imagens() {
  const [imagens, setImagens] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [atualizar, setAtualizar] = useState(false);
  const [imagemSelecionada, setImagemSelecionada] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const token = localStorage.getItem('token');
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();
  const vinculo = JSON.parse(localStorage.getItem('vinculo') || '{}');
  const entidade = vinculo?.entidade || {};
  const entidadeId = entidade.idEntidade || vinculo?.idEntidade;
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { setConfirmModal, showConfirmModal } = useConfirmModal();

  useEffect(() => {
    if (!token) {
      navigate('/');
      return;
    }
    setLoading(true);
    axios
      .get(`${API_BASE_URL.IMAGEM}/entidade/${entidadeId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(result => {
        setImagens(result.data || []);
      })
      .catch(error => {
        console.error('Erro ao obter imagens:', error);
        setImagens([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [atualizar]);

  function handleDelete(imagem) {
    showConfirmModal('delete', () => handleConfirmDelete(imagem));
  }

  function handleConfirmDelete(imagem) {
    axios
      .delete(`${API_BASE_URL.IMAGEM}/delete/${imagem.idEntidade}/${imagem.orientacao}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        setAtualizar(prev => !prev);
        setImagemSelecionada(null);
      })
      .catch(error => {
        console.error('Erro ao excluir imagem:', error);
        showDefaultModal('error', 'Erro ao excluir a imagem!');
      });
  }

  const normalizeString = str => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
  };

  const imagensFiltradas = Array.isArray(imagens)
    ? imagens.filter(img => {
        const normalizedBusca = normalizeString(filtro);
        return (
          normalizeString(img.orientacao || '').includes(normalizedBusca)
        );
      })
    : [];

  const getOrientacaoLabel = (orientacao) => {
    return orientacao === 'R' ? 'Retrato' : orientacao === 'P' ? 'Paisagem' : orientacao;
  };

  const getImagePreview = (img) => {
    if (img && img.img) {
      const bytes = atob(img.img);
      const array = new Uint8Array(bytes.length);
      for (let i = 0; i < bytes.length; i++) array[i] = bytes.charCodeAt(i);
      const blob = new Blob([array], { type: 'image/png' });
      return URL.createObjectURL(blob);
    }
    return null;
  };

  return (
    <Layout>
      <ResponsiveShadow>
        <PageHeader title="Imagens" icon="bi-image" />
        <PageContent>
          <div className="d-flex align-items-center mb-2 flex-wrap gap-2" style={{ fontSize: '0.8rem' }}>
            <button className="btn btn-success btn-sm" onClick={() => { setImagemSelecionada(null); setShowModal(true); }} title="Cadastrar nova imagem">
              <i className="bi bi-plus-circle me-1"></i>Nova
            </button>
            <button className="btn btn-primary btn-sm" disabled={!imagemSelecionada}
              onClick={() => setShowModal(true)} title="Editar imagem selecionada">
              <i className="bi bi-pencil me-1"></i>Editar
            </button>
            <button className="btn btn-danger btn-sm" disabled={!imagemSelecionada}
              onClick={() => handleDelete(imagemSelecionada)} title="Excluir imagem selecionada">
              <i className="bi bi-trash me-1"></i>Excluir
            </button>
            <span className="text-muted">|</span>
            <div className="d-flex align-items-stretch" style={{ height: '31px' }}>
              <span className="d-flex align-items-center px-2 border border-end-0 rounded-start" style={{ background: '#e9ecef', fontSize: '0.75rem' }}>
                <i className="bi bi-search"></i>
              </span>
              <input
                type="text"
                className="form-control form-control-sm border rounded-end"
                style={{ width: '180px', fontSize: '0.8rem' }}
                placeholder="Buscar..."
                value={filtro}
                onChange={e => setFiltro(e.target.value.toUpperCase())}
              />
            </div>
          </div>

          <TableContainer isLoading={isLoading}>
            <DataTable style={{ fontSize: '0.8rem' }} head={
              <tr>
                <th scope="col" className="px-2" style={{ width: '100px' }}>Preview</th>
                <th scope="col" className="px-2">Orientação</th>
                <th scope="col" className="px-2">Tamanho</th>
              </tr>}>
              <tbody>
                {!isLoading && imagensFiltradas.map((imagem) => (
                  <tr key={`${imagem.idEntidade}-${imagem.orientacao}`}
                    className={imagemSelecionada &&
                      imagemSelecionada.idEntidade === imagem.idEntidade &&
                      imagemSelecionada.orientacao === imagem.orientacao ? 'table-primary' : ''}
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      if (imagemSelecionada &&
                        imagemSelecionada.idEntidade === imagem.idEntidade &&
                        imagemSelecionada.orientacao === imagem.orientacao) {
                        setImagemSelecionada(null);
                      } else { setImagemSelecionada(imagem); }
                    }}>
                    <td className="px-2">
                      {getImagePreview(imagem) ? (
                        <img src={getImagePreview(imagem)} alt="Preview"
                          style={{ maxWidth: '150px', maxHeight: '150px', objectFit: 'contain' }} />
                      ) : (<i className="bi bi-image" style={{ fontSize: '2rem' }}></i>)}
                    </td>
                    <td className="px-2">{getOrientacaoLabel(imagem.orientacao)}</td>
                    <td className="px-2">
                      {imagem.img ? `${(imagem.img.length * 0.75 / 1024).toFixed(2)} KB` : '-'}
                    </td>
                  </tr>
                ))}
                {!isLoading && imagensFiltradas.length === 0 && (
                  <tr><td colSpan="3" className="text-center text-muted py-3">Nenhuma imagem encontrada</td></tr>
                )}
              </tbody>
            </DataTable>
          </TableContainer>

          <ConfirmModal {...setConfirmModal} />
          <DefaultModal {...setDefaultModal} />
        </PageContent>
      </ResponsiveShadow>

      {showModal && (
        <ImagemModal show={showModal} imagem={imagemSelecionada}
          onClose={() => { setShowModal(false); setImagemSelecionada(null); }}
          onSave={() => { setAtualizar(prev => !prev); setImagemSelecionada(null); }} />
      )}
    </Layout>
  );
}

export default Imagens;
